import { Component, Input, SimpleChanges, TemplateRef, OnInit, OnChanges } from '@angular/core';
import * as bs from 'bootstrap';
import { IconsService } from '../services/icons.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { OffcanvasNavbarComponent } from 'src/app/components/offcanvas/offcanvas-navbar.component';
import { SecureStorageService } from 'src/app/services/secure-storage.service';

@Component({
  selector: 'app-navbar',
  template: `
    <header class="navbar navbar-expand-lg bd-navbar bg-white shadow-sm sticky-top d-sm-block d-md-none">
      <nav class="container-xxl bd-gutter flex-wrap flex-lg-nowrap justify-content-between">
        <div class="bd-navbar-toggle">
          <button class="navbar-toggler border-0 text-dark" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasDarkNavbar" aria-controls="offcanvasDarkNavbar" aria-label="Toggle navigation" (click)="open()">
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
        <a class="navbar-brand p-0 me-0 me-lg-2" href="#"><img src="assets/images/logo-escalas-r512x512.png" width="44px"></a>
        <div class="d-flex"></div>        
      </nav>
    </header>
  `,
  styleUrls: []
})
export class NavbarComponent implements OnInit, OnChanges {
  @Input() user: any;
  
  @Input() profileLogo: any;

  permissions: any;
  school: any;

  roleLS: any = {};

  isNavbarCollapsed = true;

  protected version = environment.app_version;

  avatarURL: string = '';

  constructor(
    private router: Router,
    public icons: IconsService,
    private offcanvasService: NgbOffcanvas,
    private secureStorage: SecureStorageService
  ) {}

  ngOnInit() {
    this.loadNavbarData();
  }

  private async loadNavbarData(): Promise<void> {
    try {
      const permissionsData = await this.secureStorage.getItem('permissions');
      this.permissions = permissionsData ? JSON.parse(permissionsData) : null;
      
      const schoolData = await this.secureStorage.getItem('school');
      this.school = schoolData ? JSON.parse(schoolData) : null;
    } catch (error) {
      console.error('Error loading navbar data from encrypted storage:', error);
      this.permissions = null;
      this.school = null;
    }
  }

  open() {
    // Refresh data before opening offcanvas to ensure latest permissions
    this.loadNavbarData().then(() => {
      const offcanvasRef = this.offcanvasService.open(OffcanvasNavbarComponent, { 
        position: 'end', 
        animation: true, 
        backdrop: true, 
        keyboard: true,
        scroll: true, 
        backdropClass: 'bg-dark', 
        panelClass: 'bg-light' 
      });
      offcanvasRef.componentInstance.school = this.school;
      offcanvasRef.componentInstance.permissions = this.permissions;
      
      // Subscribe to sign out event from the offcanvas component
      offcanvasRef.componentInstance.signOut.subscribe(() => {
        this.signOut();
      });
      
      offcanvasRef.result.then((result) => {
        
      }).catch((error) => {
        
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['user'] && changes['user'].currentValue) {
      this.user = this.user;
    }
  }

  signOut() {
    let redirect = this.roleLS?.group_id == 3 ? '/user/sign-in' : '/ingresar';
    try {
      this.secureStorage.removeItem('preferences');
      this.secureStorage.removeItem('refresh_token');
      this.secureStorage.removeItem('fcm_token');
      this.secureStorage.removeItem('token');
      this.secureStorage.removeItem('user');
      this.secureStorage.removeItem('role');
      this.secureStorage.removeItem('permissions');
      this.secureStorage.removeItem('school');
      this.secureStorage.removeItem('campuses');
    } catch (error) {
      console.error('Error during sign out:', error);
    }
    globalThis.location.href = redirect;
  }
}
